<template>
    <section class="quick">
        <header-com></header-com>
        <div class='content'>
            <div>
                包拯工作室 17630316903 
            </div>
            <div class='adr_title'>
                <div>
                    天津市武清区开发区武清逸仙园小区翠柳道6号（包拯修复中心）
                </div>
                <button class="copy-btn1" v-copy="''">复制</button>
            </div>

            <div class='myCard'>
                <div class='title'>
                    <div>顺丰上门</div>
                    <radio class='radio'></radio>
                </div>
            </div>
            
            <div class='myCard'>
                <div class='title active'>
                    <div>顺丰上门</div>
                    <radio class='radio'
                        :checked='true'
                    ></radio>
                </div>
                <div class='myAdress'>
                    <div class='myAdress_title'>您的地址</div>
                    <div class='adr_lin'>
                        张某某 17630316903
                    </div>
                    <div class='setAdr'>
                        <div>
                            北京市朝阳区朝阳北路103号路明大厦
                        </div>
                        <img src='/images/public/arrow-right.png'>
                        
                    </div>
                </div>
            </div>
        </div>
        <div class='tips'>
            <div>
                *顺丰上门取件或自行邮寄均由用户自行承担邮费，部分包邮地区将在完成订单后享受邮费补助
            </div>
            
        </div>
        <div class="tool-bar f28">
            <div>
                <button class="primary pay">提交</button>
            </div>
        </div>
    </section>
</template>

<script>
  import homeApi from '@/axios/home'
  import publicObj from '@/assets/js/public';
  export default {
    name: 'index',
    data () {
      return {
          
      }
    },
    computed: {

    },
    created() {

      // this.getHomeList();
    },
    mounted(){
    
    },
    methods: {
      
      
    }
  }
</script>

<style scoped lang="scss">
    .myCard{
        box-shadow:0px 1px 13px 0px rgba(0,0,0,0.15);
        border-radius:2px;
        margin-top:40px;
        .title{
            height: 108px;
            line-height: 108px;
            color:#333333;
            font-size: 28px;
            text-indent: 20px;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
            font-weight:500;
        }
        .active{
            background: #F5F5F5;
        }
        .radio{
            margin-top: 37px;
        }
        .myAdress{
            padding-bottom: 40px;
        }
        .myAdress_title{
            font-size: 28px;
            color:#4A4A4A;
            line-height: 50px;
            text-indent: 20px;
            margin-top: 20px;
            font-weight:500;
            margin-bottom: 20px;
        }
        .adr_lin{
            display: flex;
            justify-content: flex-start;
            padding-left:20px;
            padding-right:20px;
            font-size: 24px;
        }
        .setAdr{
            display: flex;
            justify-content: space-between;
            padding-left:20px;
            padding-right:20px;
            font-size: 24px;
            position: relative;
            img{
                position: absolute;
                right: 20px;
                top:9px;
                width: 14px;
            }
        }
    }
    .tips{
        position: fixed;
        width: 100%;
        bottom:108px;
        background: #F5F5F5;
        color:#9B9B9B;
        padding: 16px 0px;
        font-size: 24px;
        div{
            margin-right: 30px;
            margin-left: 30px;
            line-height: 35px;
        }
    }
    .tool-bar{
        position: fixed;
        width: 100%;
        display: flex;
        z-index: 9;
        align-items: center;
        height: 108px;
        bottom: 0px;
        left: 0;
        background:rgba(255,255,255,1);
        box-shadow:0px -2px 20px 0px rgba(0,0,0,0.06);
        justify-content: flex-end;
        .pay{
            margin-right: 30px;
        }
    }
    .copy-btn1{
        background: #4A4A4A;
        color:#fff;
        height: 44px;
        line-height: 40px;
        font-size: 28px;
        padding:3px 32px;
        border-radius:22px;
    }
    .adr_title{
        display: flex;
        justify-content: space-between;
        border-bottom:1px dashed #e1e1e1;
        padding-bottom:32px;
    }
    .content{
        padding-top:120px;
        padding-right:30px;
        padding-left:30px;
        &>div{
            line-height: 44px;
            color:#4A4A4A;
            font-size: 28px;
        }
    }
</style>
